import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'admin-login',
    template: '',
})
export class DefaultAdminLoginComponent {}
